import request from "@/api/axios";

//购物车列表
export function cartsList(params) {
	return request({
		url: `/cart/list`,
		method: 'get',
		params
	});
}
//购物车单选
export function cartsCheck(data) {
	return request({
		url: `/cart/checkbox`,
		method: 'put',
		data
	});
}
//购物车全选
export function cartsCheckAll(data) {
	return request({
		url: `/cart/select`,
		method: 'put',
		data
	});
}
//购物车删除
export function cartsDel(id) {
	return request({
		url: `/cart/del/${id}`,
		method: 'delete',
	});
}
//清空所有无效商品
export function invalidDel() {
	return request({
		url: `/cart/failure/del`,
		method: 'delete',
	});
}
//购物车数量变更
export function cartsNumChange(data) {
	return request({
		url: `/cart/num/update`,
		method: 'put',
		data
	});
}
